import * as z from "zod";

export const LayerTypeDtoSchema = z
    .object({
        layers: z.array(
            z.object({
                code: z.string().trim(),
                name: z.string().trim(),
                source: z.string().trim(),
                legend: z
                    .object({
                        description: z.string().trim(),
                        unit: z.string().trim(),
                        min: z.number(),
                        max: z.number(),
                        color_ramp: z.array(
                            z.object({
                                value: z.number(),
                                color: z.string().trim(),
                            }),
                        ),
                    })
                    .optional(),
            }),
        ),
    })
    .readonly();

export type LayerTypeDto = z.output<typeof LayerTypeDtoSchema>;
